import { render, staticRenderFns } from "./UserLocationsDropdown.vue?vue&type=template&id=5b66e893&"
import script from "./UserLocationsDropdown.vue?vue&type=script&lang=js&"
export * from "./UserLocationsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports